export const initialState = {
  isInvoiceLocationId: null,
  isLoaded: false,
  locations: [],
};
